import api from './api';

export interface Subscription {
  id: string;
  subscription_plan: {
    id: string;
    title: string;
    price: number;
  };
  payment_receipt_filename: string;
  status: 'pending' | 'active' | 'expired' | 'rejected';
  admin_notes?: string;
  created_at: string;
}

export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string;
  price: number;
  durationDays: number;
  listingLimit: number | null;
  features: string[];
}

class PaymentReceiptsService {
  // Get available subscription plans
  async getSubscriptionPlans(): Promise<SubscriptionPlan[]> {
    const response = await api.get('/subscription-plans');
    return response.data;
  }

  // Upload payment receipt
  async uploadReceipt(file: File, subscriptionPlanId: string): Promise<{ message: string; receiptId: string }> {
    const formData = new FormData();
    formData.append('receipt', file);
    formData.append('subscriptionPlanId', subscriptionPlanId);

    const response = await api.post('/payment-receipts/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  // Get training center's subscriptions
  async getMySubscriptions(): Promise<Subscription[]> {
    const response = await api.get('/payment-receipts/my-subscriptions');
    return response.data;
  }

  // Download receipt file
  async downloadReceipt(filename: string): Promise<Blob> {
    const response = await api.get(`/payment-receipts/download/${filename}`, {
      responseType: 'blob',
    });
    return response.data;
  }
}

export default new PaymentReceiptsService();
